<div class="fe-layer" id="_referLayer">
    <div class="fe-layer-main">
        <div class="fe-layer-header">
            <span class="title">引用</span>
            <div class="delete-btn">
                <a href="javascript:;" title="关闭" role="button" class="iconfont close-layer-btn icon-guanbi3 _closeCurrLayerBtn"></a>
            </div>
        </div>
        <div class="fe-layer-content">
            <div class="refer-content">
                <ul class="refer-list">
                    <li class="paper-item">
                        <div class="tips">
                            <p>复制并粘贴一种已设定好的引用格式，或利用其中一个链接导入到文献管理软件中。</p>
                        </div>
                    </li>
                    {{each $data}}
                    <li class="paper-item">
                        <span class="paper-item-format">{{$value.type}}</span>
                        <p class="paper-item-desc _paperDesc">{{$value.desc}}</p>
                    </li>
                    <!-- <li class="paper-item">
                        <span class="paper-item-format">GB / T 7714</span>
                        <p class="paper-item-desc">Siniossoglou S，Santos-Rosa H，Rappsilber J，et al。形成球形核所需的新型膜蛋白复合物&#91J]。Embo Journal，2014,17（22）：6449-6464。</p>
                    </li>
                    <li class="paper-item">
                        <span class="paper-item-format">GB / T 7714</span>
                        <p class="paper-item-desc">Siniossoglou S，Santos-Rosa H，Rappsilber J，et al。形成球形核所需的新型膜蛋白复合物&#91J]。Embo Journal，2014,17（22）：6449-6464。</p>
                    </li>
                    <li class="paper-item">
                        <span class="paper-item-format">GB / T 7714</span>
                        <p class="paper-item-desc">Siniossoglou S，Santos-Rosa H，Rappsilber J，et al。形成球形核所需的新型膜蛋白复合物&#91J]。Embo Journal，2014,17（22）：6449-6464。</p>
                    </li>
                    <li class="paper-item">
                        <span class="paper-item-format">GB / T 7714</span>
                        <p class="paper-item-desc">Siniossoglou S，Santos-Rosa H，Rappsilber J，et al。形成球形核所需的新型膜蛋白复合物&#91J]。Embo Journal，2014,17（22）：6449-6464。</p>
                    </li>
                    <li class="paper-item">
                        <span class="paper-item-format">GB / T 7714</span>
                        <p class="paper-item-desc">Siniossoglou S，Santos-Rosa H，Rappsilber J，et al。形成球形核所需的新型膜蛋白复合物&#91J]。Embo Journal，2014,17（22）：6449-6464。</p>
                    </li> -->
                    {{/each}}
                </ul>
            </div>
            <div class="import-link-content max-margin">
                <span>导入链接</span>
                <ul>
                    <li><a href="javascript:;" class="_importLink" data-type="1">BibTeX</a></li>
                    <li><a href="javascript:;" class="_importLink" data-type="1">EndNote</a></li>
                    <li><a href="javascript:;" class="_importLink" data-type="1">RefMan</a></li>
                    <li><a href="javascript:;" class="_importLink" data-type="1">NoteFirst</a></li>
                    <li><a href="javascript:;" class="_importLink" data-type="1">NoteExpress</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>